import { FC } from 'react';

import { PlaceholderBar } from '../../components/loading-skeleton/index';

const CompanyCardSkeleton: FC = () => (
  <div className="flex h-fit w-full max-w-[400px] flex-col gap-2 rounded-lg bg-gray-50 p-[2px] pt-2 shadow-sm">
    <div className="flex justify-center py-1">
      <PlaceholderBar className="h-3 w-28 rounded bg-gray-100" />
    </div>
    <div className="flex w-full flex-col divide-y divide-gray-100 rounded-md bg-white">
      <div className="flex w-full items-center justify-between p-4">
        <div className="flex items-center gap-2">
          <PlaceholderBar className="size-9 shrink-0 rounded-full bg-gray-100" />
          <PlaceholderBar className="h-4 w-32 rounded bg-gray-100" />
        </div>
        <PlaceholderBar className="size-6 rounded bg-gray-100" />
      </div>
      {Array.from({ length: 4 }).map((_, index) => (
        <div className="flex w-full items-center justify-between p-4 py-[10px]" key={index}>
          <PlaceholderBar className="h-3 w-24 rounded bg-gray-100" />
          <PlaceholderBar className="h-3 w-20 rounded bg-gray-100" />
        </div>
      ))}
    </div>
  </div>
);

type MyCompaniesPlaceholderProps = {
  cards?: number;
};

export const MyCompaniesPlaceholder: FC<MyCompaniesPlaceholderProps> = ({ cards = 2 }) => (
  <div className="flex h-fit w-full animate-pulse flex-wrap items-stretch justify-start gap-4 p-4 max-lg:justify-center">
    {Array.from({ length: cards }).map((_, index) => (
      <CompanyCardSkeleton key={index} />
    ))}
  </div>
);
